export const LicenseType = {
  ENTERPRISE: 1,
  NIAP: 2,
  DEVELOPERS: 3,
  ONDEMAND: 4,
  TRIAL: 5,
};
